import { render, staticRenderFns } from "./DBLWarning.vue?vue&type=template&id=ea2c91e4&"
import script from "./DBLWarning.vue?vue&type=script&lang=js&"
export * from "./DBLWarning.vue?vue&type=script&lang=js&"
import style0 from "./DBLWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea2c91e4')) {
      api.createRecord('ea2c91e4', component.options)
    } else {
      api.reload('ea2c91e4', component.options)
    }
    module.hot.accept("./DBLWarning.vue?vue&type=template&id=ea2c91e4&", function () {
      api.rerender('ea2c91e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/彈窗/DBLWarning.vue"
export default component.exports